import EximMasterFreightIndex from "@/components/exim/billing/master_freight/EximMasterFreightIndex.vue";
import EximMasterFreightUpload from "@/components/exim/billing/master_freight/EximMasterFreightUpload.vue";

let EximMasterFreightRoute= [
    {
        path: '',
        meta: {
          title: "Exim Billing Master Freight",
        },
        name: "EximMasterFreightIndex",
        component: EximMasterFreightIndex
    },
    {
      path: 'upload',
      meta: {
        title: "Exim Billing Master Freight Upload",
      },
      name: "EximMasterFreightUpload",
      component: EximMasterFreightUpload
    }
    
]

export default EximMasterFreightRoute
  